import { GrooveAPI } from 'api/groove'
import config from 'config'

export default new GrooveAPI({
  apiUrl: config.integrationsApiUrl,
  concurrency: config.integrationsApiConcurrency,
  withCredentials: false,
})
